<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Question History</span>
    <a class="button waves-effect" (click)="onNoClick()">
      <i class="material-icons button__icon">cancel</i>
      <span class="button__text">Close</span>
    </a>
  </div>
  <div class="ttmodal__body" *ngIf="historyList.length > 0"
    style="display: flex; flex-direction: column; margin-top: 10px;">
    <span class="ttmodal__title">Viewing history for Question </span>
    <span class="ttmodal__title"><b>{{QuestionHistoryresult.QTitle}} </b></span>
    <table class="table table--full-width table--striped table--hover" style="height: 200px; overflow-y: auto; margin-top: 10px;">
      <tbody>
        <ng-container *ngFor="let fq of historyList">
          <tr style="border: groove;">
            <td>
              <div *ngIf="fq.SelectedQuestion" style="display: flex; flex-direction: column;color: blue;">
                <span><b>Completed Date: </b>{{fq.CompletedDate}}</span>
                <span><b>Form Name: </b>{{fq.FormName}}</span>
                <span><b>Answer: </b>{{fq.Amswers}}</span>
                <span><b>Answered By: </b>{{fq.InspectorName | aesDecrypt}}</span>
              </div>
              <div *ngIf="!fq.SelectedQuestion" style="display: flex; flex-direction: column;">
                <span><b>Completed Date: </b>{{fq.CompletedDate}}</span>
                <span><b>Form Name: </b>{{fq.FormName}}</span>
                <span><b>Answer: </b>{{fq.Amswers}}</span>
                <span><b>Answered By: </b>{{fq.InspectorName | aesDecrypt}}</span>
              </div>
            </td>
            <td>
              <i *ngIf="fq.QuestionImages.length == 0" class="material-icons button__icon"
                style="font-size: 28px; margin-right: 20px;vertical-align: middle;">camera_alt</i>
                <div *ngIf="fq.QuestionImages.length > 0">
                  <ng-container  *ngFor="let photo of fq.QuestionImages">
                  <img class="inspection-observation-photo" [src]="photo"/>
              </ng-container>
                </div>
              <!-- <i *ngIf="fq.QuestionImages!=null" class="material-icons button__icon"
                style="font-size: 28px; margin-right: 20px;color: royalblue;vertical-align: middle;">camera_alt</i> -->
            </td>
            <td>
              <!-- <i *ngIf="fq.QuestionCommment!=''" class="material-icons button__icon"
                style="font-size: 28px; color: royalblue;vertical-align: middle; margin-right: 20px;"
                title="{{fq.QuestionCommment}}">assignment</i> -->
               <span  *ngIf="fq.QuestionCommment!=''" [matTooltip]="fq.QuestionCommment" matTooltipPosition="above" style="cursor: pointer;">
                {{ fq.QuestionCommment?.length > 25 ? (fq.QuestionCommment | slice:0:25) + '...' : fq.QuestionCommment }}
              </span>
              <i *ngIf="fq.QuestionCommment==''" class="material-icons button__icon"
                style="font-size: 28px; vertical-align: middle; margin-right: 20px;">assignment</i>
            </td>
            <td>
              <a (click)="LoadSelectedCatData(fq.FormId,fq.SectionId, fq.QId, fq.UploadId)">
                <i class="material-icons button__icon"
                  style="font-size: 28px; vertical-align: middle; margin-right: 20px; cursor: pointer;">pageview</i></a>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="historyList.length==0" class="ttmodal__body"
    style="display: flex; flex-direction: column;align-items: center; margin-top: 10%;">
    <span class="ttmodal__title" style="font-size: large;"> There is no Question History to View </span>
  </div>
</div>